import React, {useEffect, useState} from 'react';
import './financeEvents.scss';
import {Button, HeadingElement, InfoCard} from "../../../../components";
import {useNavigate} from "react-router-dom";
import {InfoCardType} from "../../../../models";
import {newsData} from "../../../../data/newsData";

const FinanceEvents = () => {
    const navigate = useNavigate();
    const [events, setEvents] = useState<InfoCardType[]>(newsData.filter((data) => (data.isPopular === true)));

    useEffect(() => {
        setEvents(newsData.filter((data) => (data.isPopular === true)));
    }, []);

    return (
        <div className={'finance-events'} id={'business_upcoming_events'}>
            <div className="finance-events_wrapper max">
                <div className={'finance-events_wrapper_left'}>
                    <HeadingElement/>
                    <h1>Upcoming <br/> Events & Programs</h1>
                    <p>Check out our upcoming events geared towards helping small businesses grow in Jamaica.</p>
                    <div className={'finance-events_wrapper_left_cta'}>
                        <Button text={'View All'} type={'primary'} onclick={() => navigate("/events")}/>
                    </div>
                </div>
                <div className={'finance-events_wrapper_right'}>
                    {events.slice(0, 2).map(({id, date, heading, description, link, image}, index) => (
                        <InfoCard key={index.toString() + id} id={id} date={date} heading={heading}
                                  description={description} link={link}
                                  image={image}/>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FinanceEvents;
